'use strict';
import * as $j_app$002edata$002e$002dApp$002dDocument$002dLineage$002dRequest from "./app.data.-App-Document-Lineage-Request.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_AppDocumentLineageRequest$NewVersion(docId) {
  this.a8u = null;
  this.a8u = docId;
}
export { $c_Lapp_data_AppDocumentLineageRequest$NewVersion as $c_Lapp_data_AppDocumentLineageRequest$NewVersion };
$p = $c_Lapp_data_AppDocumentLineageRequest$NewVersion.prototype = new $j_app$002edata$002e$002dApp$002dDocument$002dLineage$002dRequest.$h_Lapp_data_AppDocumentLineageRequest();
$p.constructor = $c_Lapp_data_AppDocumentLineageRequest$NewVersion;
/** @constructor */
function $h_Lapp_data_AppDocumentLineageRequest$NewVersion() {
}
export { $h_Lapp_data_AppDocumentLineageRequest$NewVersion as $h_Lapp_data_AppDocumentLineageRequest$NewVersion };
$h_Lapp_data_AppDocumentLineageRequest$NewVersion.prototype = $p;
$p.p = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().P(this, (-889275714), false);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lapp_data_AppDocumentLineageRequest$NewVersion)) {
    var x = this.a8u;
    var x$2 = x$0.a8u;
    return ((x === null) ? (x$2 === null) : x.f(x$2));
  } else {
    return false;
  }
});
$p.n = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().V(this);
});
$p.s = (function() {
  return 1;
});
$p.t = (function() {
  return "NewVersion";
});
$p.e = (function(n) {
  if ((n === 0)) {
    return this.a8u;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.u = (function(n) {
  if ((n === 0)) {
    return "docId";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.co = (function() {
  return 0;
});
function $isArrayOf_Lapp_data_AppDocumentLineageRequest$NewVersion(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.j6)));
}
export { $isArrayOf_Lapp_data_AppDocumentLineageRequest$NewVersion as $isArrayOf_Lapp_data_AppDocumentLineageRequest$NewVersion };
var $d_Lapp_data_AppDocumentLineageRequest$NewVersion = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_AppDocumentLineageRequest$NewVersion, "app.data.AppDocumentLineageRequest$NewVersion", ({
  j6: 1,
  fQ: 1,
  b: 1,
  c: 1,
  a: 1,
  l: 1
}));
export { $d_Lapp_data_AppDocumentLineageRequest$NewVersion as $d_Lapp_data_AppDocumentLineageRequest$NewVersion };
//# sourceMappingURL=app.data.-App-Document-Lineage-Request$-New-Version.js.map
